import { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';
const JobAdInformativeText: FunctionComponent = () => {
  const { t } = useTranslation('job-position-page');
  return <p className="font-normal text-gray-500">{t('job_ad_informative_text')}</p>;
};

// const JobAdInformativeTextDesktop: FunctionComponent = () => (
//   <span className="hidden md:block">
//     <JobAdInformativeText />
//   </span>
// );

// const JobAdInformativeTextMobile: FunctionComponent = () => (
//   <span className="md:hidden">
//     <JobAdInformativeText />
//   </span>
// );

export { JobAdInformativeText };
